/***
 *
 *   KANBAN COLUMN STYLES
 *   Ported from ui-reference/src/components/tickets/kanban-column.tsx.
 *
 **********/

const Style = {
    container:
        'flex min-w-[280px] flex-1 snap-start flex-col overflow-hidden rounded-lg border border-border/25 bg-muted/20',
    header: 'rounded-t-lg bg-muted/50 px-3 pb-0 pt-3',
    headerRow: 'flex items-baseline justify-between gap-3',
    title: 'text-xs font-semibold uppercase tracking-wide text-text-secondary',
    count: 'shrink-0 text-xs tabular-nums text-text-muted',
    body: 'scrollbar-kanban min-h-0 flex-1 overflow-y-auto p-2 pt-3',
    droppable: 'min-h-[120px] space-y-2 rounded-md transition-colors',
    droppableActive: 'bg-primary-50/50 dark:bg-primary-900/20',
    empty: 'flex min-h-[104px] flex-col items-center justify-center gap-1 rounded-md border border-dashed border-border/80 bg-muted/10 px-3 py-5 text-center',
    emptyActive:
        'border-primary-400/50 bg-primary-50/40 dark:border-primary-600/50 dark:bg-primary-900/30',
    emptyTitle: 'text-xs font-medium text-text-secondary',
    emptyHint: 'max-w-[220px] text-[11px] leading-snug text-text-muted',
};

/** Status accent bar — unknown keys fall back to closed (neutral grey). Trap 5. */
export const STATUS_BAR = {
    pending: 'bg-status-pending',
    in_progress: 'bg-status-inProgress',
    on_hold: 'bg-status-onHold',
    completed: 'bg-status-completed',
    closed: 'bg-status-closed',
};

export default Style;
